import { FiltersBarModel } from '@_types/types';
import { getModifiers } from '@helpers/functions';
import Icon from '@atoms/icons/Icon';
import RequireJs from '@helpers/RequireJs';

const FiltersBar = (model: FiltersBarModel) => {
  const styleModifier = getModifiers(model, 'kf-m-filters-bar');
  const { selectedFilters, totalResults, items, searchId, itemType, excludeJs, disabled } = model;

  return (
    <div className={`${styleModifier} kf-container`} data-disabled={disabled} data-item-type={itemType} data-search-id={searchId}>
      {!disabled && (
        <>
          {selectedFilters && (
            <div className="kf-m-filters-bar__selected-filter">
              <p className="kf-m-filters-bar__text-content">{selectedFilters}</p>
            </div>
          )}

          {items && items?.length > 0 && (
            <div className="kf-m-filters-bar__filter-items">
              {items?.map((item) => (
                <div key={item?.value} className="kf-m-filters-bar__filter-item" data-value={item?.value} role="button" tabIndex={0}>
                  <p className="kf-m-filters-bar__filter-item-text">{item.text}</p>
                  <Icon className="kf-m-filters-bar__filter-item-icon" iconPath="#kf-close" viewBoxHeight={24} viewBoxWidth={24} />
                </div>
              ))}
            </div>
          )}
        </>
      )}

      <div className="kf-m-filters-bar__result">
        <p className="kf-m-filters-bar__text-content">{totalResults}</p>
      </div>

      {!excludeJs && <RequireJs defer path={'filters-bar'} />}
    </div>
  );
};

export default FiltersBar;
